import { useState, type FormEvent } from "react";
import { useNavigate } from "react-router-dom";
import { supabase } from "../lib/supabase.js";
import { useAuth } from "../lib/auth.js";
import { Button, Input } from "../lib/ui.js";

/**
 * Landing page for BOTH an invite-accept link and a forgot-password link (Supabase fires
 * the same PASSWORD_RECOVERY event for both -- lib/auth.tsx). Guards.tsx routes any
 * signed-in session with needsPasswordSetup=true here before it can reach /app or /admin.
 */
export function SetPassword() {
  const { clearPasswordSetup } = useAuth();
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [status, setStatus] = useState<"idle" | "working" | "error">("idle");
  const [error, setError] = useState<string | null>(null);

  async function handleSubmit(e: FormEvent) {
    e.preventDefault();
    if (password !== confirm) {
      setStatus("error");
      setError("Passwords don't match.");
      return;
    }
    if (password.length < 8) {
      setStatus("error");
      setError("Use at least 8 characters.");
      return;
    }
    setStatus("working");
    setError(null);
    const { error: err } = await supabase.auth.updateUser({ password });
    if (err) {
      setStatus("error");
      setError(err.message);
      return;
    }
    clearPasswordSetup();
    navigate("/", { replace: true });
  }

  return (
    <div className="rc-auth">
      <div className="rc-auth-panel">
        <div className="rc-auth-brand">
          <span className="rc-mark" aria-hidden="true">
            R
          </span>
          Receptionist
        </div>
        <div className="rc-card" style={{ padding: 28 }}>
          <h1 className="rc-h1" style={{ marginBottom: 4 }}>Set your password</h1>
          <p style={{ fontSize: 14, color: "var(--rc-text-muted)", marginTop: 0, marginBottom: 20 }}>
            You can turn on an authenticator app afterwards from Security in the sidebar.
          </p>
          <form onSubmit={handleSubmit}>
            <label style={labelStyle}>
              New password
              <Input type="password" autoComplete="new-password" required autoFocus value={password} onChange={(e) => setPassword(e.target.value)} />
            </label>
            <label style={labelStyle}>
              Confirm password
              <Input type="password" autoComplete="new-password" required value={confirm} onChange={(e) => setConfirm(e.target.value)} />
            </label>
            <Button variant="primary" type="submit" disabled={status === "working"} style={{ width: "100%", padding: "10px 14px", marginTop: 4 }}>
              {status === "working" ? "Saving..." : "Save and continue"}
            </Button>
            {error && (
              <p role="alert" style={{ color: "var(--rc-danger)", fontSize: 13.5, margin: "12px 0 0" }}>
                {error}
              </p>
            )}
          </form>
        </div>
      </div>
    </div>
  );
}

const labelStyle: React.CSSProperties = { display: "flex", flexDirection: "column", gap: 6, marginBottom: 14, fontSize: 13, fontWeight: 600, color: "var(--rc-text-muted)" };
